import moment from 'moment'
import M from 'materialize-css'
const countries = [
  {
    "c": "AX",
    "name": "Åland Islands"
  },
  {
    "c": "PK",
    "name": "Pakistan"
  },
  {
    "c": "SE",
    "name": "Sweden"
  },
  {
    "c": "BV",
    "name": "Bouvet Island"
  },
  {
    "c": "BY",
    "name": "Belarus"
  },
  {
    "c": "NL",
    "name": "Netherlands"
  },
  {
    "c": "TO",
    "name": "Tonga"
  },
  {
    "c": "MV",
    "name": "Maldives"
  },
  {
    "c": "BR",
    "name": "Brazil"
  },
  {
    "c": "MK",
    "name": "Macedonia"
  },
  {
    "c": "IT",
    "name": "Italy"
  },
  {
    "c": "KN",
    "name": "Saint Kitts and Nevis"
  },
  {
    "c": "SO",
    "name": "Somalia"
  },
  {
    "c": "LS",
    "name": "Lesotho"
  },
  {
    "c": "CD",
    "name": "Congo, Democratic Republic"
  },
  {
    "c": "KH",
    "name": "Cambodia"
  },
  {
    "c": "PN",
    "name": "Pitcairn"
  },
  {
    "c": "SC",
    "name": "Seychelles"
  },
  {
    "c": "YE",
    "name": "Yemen"
  },
  {
    "c": "SH",
    "name": "Saint Helena"
  },
  {
    "c": "SA",
    "name": "Saudi Arabia"
  },
  {
    "c": "FK",
    "name": "Falkland Islands (Malvinas)"
  },
  {
    "c": "CV",
    "name": "Cape Verde"
  },
  {
    "c": "CU",
    "name": "Cuba"
  },
  {
    "c": "HK",
    "name": "Hong Kong"
  },
  {
    "c": "PW",
    "name": "Palau"
  },
  {
    "c": "FM",
    "name": "Micronesia"
  },
  {
    "c": "EE",
    "name": "Estonia"
  },
  {
    "c": "LT",
    "name": "Lithuania"
  },
  {
    "c": "NO",
    "name": "Norway"
  },
  {
    "c": "MC",
    "name": "Monaco"
  },
  {
    "c": "BW",
    "name": "Botswana"
  },
  {
    "c": "BN",
    "name": "Brunei Darussalam"
  },
  {
    "c": "ER",
    "name": "Eritrea"
  },
  {
    "c": "CI",
    "name": "Cote D\"Ivoire"
  },
  {
    "c": "BJ",
    "name": "Benin"
  },
  {
    "c": "BM",
    "name": "Bermuda"
  },
  {
    "c": "GP",
    "name": "Guadeloupe"
  },
  {
    "c": "GG",
    "name": "Guernsey"
  },
  {
    "c": "VE",
    "name": "Venezuela"
  },
  {
    "c": "AF",
    "name": "Afghanistan"
  },
  {
    "c": "ST",
    "name": "Sao Tome and Principe"
  },
  {
    "c": "JE",
    "name": "Jersey"
  },
  {
    "c": "BD",
    "name": "Bangladesh"
  },
  {
    "c": "JP",
    "name": "Japan"
  },
  {
    "c": "DE",
    "name": "Germany"
  },
  {
    "c": "GE",
    "name": "Georgia"
  },
  {
    "c": "TW",
    "name": "Taiwan, Province of China"
  },
  {
    "c": "CN",
    "name": "China"
  },
  {
    "c": "AE",
    "name": "United Arab Emirates"
  },
  {
    "c": "NA",
    "name": "Namibia"
  },
  {
    "c": "MS",
    "name": "Montserrat"
  },
  {
    "c": "TG",
    "name": "Togo"
  },
  {
    "c": "KI",
    "name": "Kiribati"
  },
  {
    "c": "OM",
    "name": "Oman"
  },
  {
    "c": "NP",
    "name": "Nepal"
  },
  {
    "c": "CM",
    "name": "Cameroon"
  },
  {
    "c": "WF",
    "name": "Wallis and Futuna"
  },
  {
    "c": "SG",
    "name": "Singapore"
  },
  {
    "c": "SL",
    "name": "Sierra Leone"
  },
  {
    "c": "TZ",
    "name": "Tanzania"
  },
  {
    "c": "UA",
    "name": "Ukraine"
  },
  {
    "c": "TC",
    "name": "Turks and Caicos Islands"
  },
  {
    "c": "PY",
    "name": "Paraguay"
  },
  {
    "c": "FR",
    "name": "France"
  },
  {
    "c": "XK",
    "name": "Kosovo"
  },
  {
    "c": "KR",
    "name": "Korea (South)"
  },
  {
    "c": "MX",
    "name": "Mexico"
  },
  {
    "c": "PE",
    "name": "Peru"
  },
  {
    "c": "HT",
    "name": "Haiti"
  },
  {
    "c": "EH",
    "name": "Western Sahara"
  },
  {
    "c": "EG",
    "name": "Egypt"
  },
  {
    "c": "RW",
    "name": "Rwanda"
  },
  {
    "c": "AR",
    "name": "Argentina"
  },
  {
    "c": "KW",
    "name": "Kuwait"
  },
  {
    "c": "PH",
    "name": "Philippines"
  },
  {
    "c": "LK",
    "name": "Sri Lanka"
  },
  {
    "c": "RE",
    "name": "Reunion"
  },
  {
    "c": "VG",
    "name": "Virgin Islands, British"
  },
  {
    "c": "AW",
    "name": "Aruba"
  },
  {
    "c": "GQ",
    "name": "Equatorial Guinea"
  },
  {
    "c": "ME",
    "name": "Montenegro"
  },
  {
    "c": "PA",
    "name": "Panama"
  },
  {
    "c": "CG",
    "name": "Congo"
  },
  {
    "c": "KY",
    "name": "Cayman Islands"
  },
  {
    "c": "MA",
    "name": "Morocco"
  },
  {
    "c": "NG",
    "name": "Nigeria"
  },
  {
    "c": "NI",
    "name": "Nicaragua"
  },
  {
    "c": "SM",
    "name": "San Marino"
  },
  {
    "c": "DK",
    "name": "Denmark"
  },
  {
    "c": "MT",
    "name": "Malta"
  },
  {
    "c": "DO",
    "name": "Dominican Republic"
  },
  {
    "c": "DJ",
    "name": "Djibouti"
  },
  {
    "c": "AD",
    "name": "AndorrA"
  },
  {
    "c": "BI",
    "name": "Burundi"
  },
  {
    "c": "BB",
    "name": "Barbados"
  },
  {
    "c": "LB",
    "name": "Lebanon"
  },
  {
    "c": "BH",
    "name": "Bahrain"
  },
  {
    "c": "ZA",
    "name": "South Africa"
  },
  {
    "c": "JM",
    "name": "Jamaica"
  },
  {
    "c": "PS",
    "name": "Palestinian Territory, Occupied"
  },
  {
    "c": "TT",
    "name": "Trinidad and Tobago"
  },
  {
    "c": "NU",
    "name": "Niue"
  },
  {
    "c": "BE",
    "name": "Belgium"
  },
  {
    "c": "PL",
    "name": "Poland"
  },
  {
    "c": "AO",
    "name": "Angola"
  },
  {
    "c": "SK",
    "name": "Slovakia"
  },
  {
    "c": "GL",
    "name": "Greenland"
  },
  {
    "c": "UG",
    "name": "Uganda"
  },
  {
    "c": "KE",
    "name": "Kenya"
  },
  {
    "c": "YT",
    "name": "Mayotte"
  },
  {
    "c": "CY",
    "name": "Cyprus"
  },
  {
    "c": "AQ",
    "name": "Antarctica"
  },
  {
    "c": "AG",
    "name": "Antigua and Barbuda"
  },
  {
    "c": "IS",
    "name": "Iceland"
  },
  {
    "c": "HN",
    "name": "Honduras"
  },
  {
    "c": "HM",
    "name": "Heard Island and Mcdonald Islands"
  },
  {
    "c": "RS",
    "name": "Serbia"
  },
  {
    "c": "TH",
    "name": "Thailand"
  },
  {
    "c": "TK",
    "name": "Tokelau"
  },
  {
    "c": "BZ",
    "name": "Belize"
  },
  {
    "c": "GR",
    "name": "Greece"
  },
  {
    "c": "UY",
    "name": "Uruguay"
  },
  {
    "c": "CX",
    "name": "Christmas Island"
  },
  {
    "c": "PR",
    "name": "Puerto Rico"
  },
  {
    "c": "AL",
    "name": "Albania"
  },
  {
    "c": "JO",
    "name": "Jordan"
  },
  {
    "c": "SB",
    "name": "Solomon Islands"
  },
  {
    "c": "DZ",
    "name": "Algeria"
  },
  {
    "c": "TN",
    "name": "Tunisia"
  },
  {
    "c": "LY",
    "name": "Libyan Arab Jamahiriya"
  },
  {
    "c": "LU",
    "name": "Luxembourg"
  },
  {
    "c": "TR",
    "name": "Turkey"
  },
  {
    "c": "SN",
    "name": "Senegal"
  },
  {
    "c": "CZ",
    "name": "Czech Republic"
  },
  {
    "c": "GI",
    "name": "Gibraltar"
  },
  {
    "c": "MG",
    "name": "Madagascar"
  },
  {
    "c": "BS",
    "name": "Bahamas"
  },
  {
    "c": "MQ",
    "name": "Martinique"
  },
  {
    "c": "NE",
    "name": "Niger"
  },
  {
    "c": "NF",
    "name": "Norfolk Island"
  },
  {
    "c": "MD",
    "name": "Moldova"
  },
  {
    "c": "AZ",
    "name": "Azerbaijan"
  },
  {
    "c": "BO",
    "name": "Bolivia"
  },
  {
    "c": "MZ",
    "name": "Mozambique"
  },
  {
    "c": "IO",
    "name": "British Indian Ocean Territory"
  },
  {
    "c": "TM",
    "name": "Turkmenistan"
  },
  {
    "c": "SV",
    "name": "El Salvador"
  },
  {
    "c": "UM",
    "name": "United States Minor Outlying Islands"
  },
  {
    "c": "CH",
    "name": "Switzerland"
  },
  {
    "c": "TJ",
    "name": "Tajikistan"
  },
  {
    "c": "AI",
    "name": "Anguilla"
  },
  {
    "c": "UZ",
    "name": "Uzbekistan"
  },
  {
    "c": "ES",
    "name": "Spain"
  },
  {
    "c": "CK",
    "name": "Cook Islands"
  },
  {
    "c": "KZ",
    "name": "Kazakhstan"
  },
  {
    "c": "US",
    "name": "United States"
  },
  {
    "c": "FI",
    "name": "Finland"
  },
  {
    "c": "IM",
    "name": "Isle of Man"
  },
  {
    "c": "GW",
    "name": "Guinea-Bissau"
  },
  {
    "c": "IR",
    "name": "Iran"
  },
  {
    "c": "GT",
    "name": "Guatemala"
  },
  {
    "c": "WS",
    "name": "Samoa"
  },
  {
    "c": "NZ",
    "name": "New Zealand"
  },
  {
    "c": "VN",
    "name": "Viet Nam"
  },
  {
    "c": "TV",
    "name": "Tuvalu"
  },
  {
    "c": "SI",
    "name": "Slovenia"
  },
  {
    "c": "VU",
    "name": "Vanuatu"
  },
  {
    "c": "GD",
    "name": "Grenada"
  },
  {
    "c": "IN",
    "name": "India"
  },
  {
    "c": "SY",
    "name": "Syrian Arab Republic"
  },
  {
    "c": "AT",
    "name": "Austria"
  },
  {
    "c": "MR",
    "name": "Mauritania"
  },
  {
    "c": "CR",
    "name": "Costa Rica"
  },
  {
    "c": "ET",
    "name": "Ethiopia"
  },
  {
    "c": "CC",
    "name": "Cocos (Keeling) Islands"
  },
  {
    "c": "GB",
    "name": "United Kingdom"
  },
  {
    "c": "NR",
    "name": "Nauru"
  },
  {
    "c": "AU",
    "name": "Australia"
  },
  {
    "c": "GU",
    "name": "Guam"
  },
  {
    "c": "SR",
    "name": "Surid"
  },
  {
    "c": "VI",
    "name": "Virgin Islands, U.S."
  },
  {
    "c": "BF",
    "name": "Burkina Faso"
  },
  {
    "c": "GF",
    "name": "French Guiana"
  },
  {
    "c": "MO",
    "name": "Macao"
  },
  {
    "c": "RO",
    "name": "Romania"
  },
  {
    "c": "SJ",
    "name": "Svalbard and Jan Mayen"
  },
  {
    "c": "LA",
    "name": "Laos"
  },
  {
    "c": "CA",
    "name": "Canada"
  },
  {
    "c": "PM",
    "name": "Saint Pierre and Miquelon"
  },
  {
    "c": "IQ",
    "name": "Iraq"
  },
  {
    "c": "MU",
    "name": "Mauritius"
  },
  {
    "c": "KM",
    "name": "Comoros"
  },
  {
    "c": "GA",
    "name": "Gabon"
  },
  {
    "c": "IL",
    "name": "Israel"
  },
  {
    "c": "LV",
    "name": "Latvia"
  },
  {
    "c": "VC",
    "name": "Saint Vincent and the Grenadines"
  },
  {
    "c": "SD",
    "name": "Sudan"
  },
  {
    "c": "PF",
    "name": "French Polynesia"
  },
  {
    "c": "MW",
    "name": "Malawi"
  },
  {
    "c": "AS",
    "name": "American Samoa"
  },
  {
    "c": "MP",
    "name": "Northern Mariana Islands"
  },
  {
    "c": "TF",
    "name": "French Southern Territories"
  },
  {
    "c": "KP",
    "name": "Korea (North)"
  },
  {
    "c": "HU",
    "name": "Hungary"
  },
  {
    "c": "RU",
    "name": "Russian Federation"
  },
  {
    "c": "GH",
    "name": "Ghana"
  },
  {
    "c": "ML",
    "name": "Mali"
  },
  {
    "c": "TL",
    "name": "Timor-Leste"
  },
  {
    "c": "BG",
    "name": "Bulgaria"
  },
  {
    "c": "GN",
    "name": "Guinea"
  },
  {
    "c": "PT",
    "name": "Portugal"
  },
  {
    "c": "ID",
    "name": "Indonesia"
  },
  {
    "c": "MY",
    "name": "Malaysia"
  },
  {
    "c": "DM",
    "name": "Dominica"
  },
  {
    "c": "FO",
    "name": "Faroe Islands"
  },
  {
    "c": "ZM",
    "name": "Zambia"
  },
  {
    "c": "BA",
    "name": "Bosnia and Herzegovina"
  },
  {
    "c": "CL",
    "name": "Chile"
  },
  {
    "c": "LI",
    "name": "Liechtenstein"
  },
  {
    "c": "PG",
    "name": "Papua New Guinea"
  },
  {
    "c": "CO",
    "name": "Colombia"
  },
  {
    "c": "CF",
    "name": "Central African Republic"
  },
  {
    "c": "IE",
    "name": "Ireland"
  },
  {
    "c": "ZW",
    "name": "Zimbabwe"
  },
  {
    "c": "FJ",
    "name": "Fiji"
  },
  {
    "c": "TD",
    "name": "Chad"
  },
  {
    "c": "SZ",
    "name": "Swaziland"
  },
  {
    "c": "GS",
    "name": "South Georgia and the South Sandwich Islands"
  },
  {
    "c": "LR",
    "name": "Liberia"
  },
  {
    "c": "BT",
    "name": "Bhutan"
  },
  {
    "c": "AM",
    "name": "Armenia"
  },
  {
    "c": "VA",
    "name": "Holy See (Vatican City State)"
  },
  {
    "c": "GY",
    "name": "Guyana"
  },
  {
    "c": "HR",
    "name": "Croatia"
  },
  {
    "c": "NC",
    "name": "New Caledonia"
  },
  {
    "c": "MH",
    "name": "Marshall Islands"
  },
  {
    "c": "GM",
    "name": "Gambia"
  },
  {
    "c": "QA",
    "name": "Qatar"
  },
  {
    "c": "MM",
    "name": "Myanmar"
  },
  {
    "c": "KG",
    "name": "Kyrgyzstan"
  },
  {
    "c": "MN",
    "name": "Mongolia"
  },
  {
    "c": "AN",
    "name": "Netherlands Antilles"
  },
  {
    "c": "LC",
    "name": "Saint Lucia"
  },
  {
    "c": "EC",
    "name": "Ecuador"
  }
]
const cleanUpToasts = (cbf) => {
  try {
   // M.Toast.dismissAll()
    let toastElement = document.querySelectorAll('.toast')
    toastElement.forEach(e => {
      M.Toast.getInstance(e).dismiss()
    })
    //let toastInstance = M.Toast.getInstance(toastElement)
    //toastInstance.dismiss()
  // eslint-disable-next-line no-empty
  } catch (error) { }
  setTimeout(() => {
    cbf()
  }, 50);
}
export const initTabs = (el, options) => {
  const instance = M.Tabs.init(el, options);
  return instance;
};
export const toastMessage = (message, callback) => {
  const execute = () => {
    return M.toast({html:message, completeCallback:()=>{
      callback 
     ? callback()
     : ''
    }})
  }
  cleanUpToasts(execute)
 }
 export const dateFormat = (date, format) => {
  return  moment(date).format(format)
}
 export const initModal = (el,options) => {
  const instance = M.Modal.init(el,options)
  return instance
}
const initAutoComplete = (el, options) => {
  const instance = M.Autocomplete.init(el, options)
  return instance
}
export const updateFields = () =>{
  M.updateTextFields()
}
const fieldsToText = (values, title, prop, prop_two, prop_three) => {
  let newDiv =  document.createElement('DIV')  
  newDiv.innerHTML = values  
  let titleDiv = document.createElement('DIV')
  titleDiv.innerHTML = title
  let propOne = document.createElement('DIV')
  propOne.innerHTML = `&nbsp; ${prop}`
  let pt = document.createElement('DIV')
  pt.innerHTML = `&nbsp; ${prop_two}`     
  let pth = document.createElement('DIV')
  pth.innerHTML = `&nbsp; ${prop_three}`

   newDiv.append(titleDiv)
   prop? newDiv.append(propOne) : ''
   pt? newDiv.append(pt) : ''
   pth? newDiv.append(pth) : ''
   return newDiv.textContent
 }
 const createFieldsText = (arr) =>{
   let newDiv = document.createElement('DIV')
    const in_fields = (field) =>{
      let div = document.createElement('DIV')
      div.innerHTML = ` ${field}`
      return div.textContent
    }
    arr.forEach(item => newDiv.append(in_fields(item)))
    return newDiv.textContent
 }
 export default {
   toastMessage, initModal, initAutoComplete, fieldsToText, updateFields, dateFormat, createFieldsText, countries
 }